import * as React from "react";
import * as ReactDOM from "react-dom";
import {logStore} from './store/store';
import {PowerMapGame} from "./app/PowerMapGame";



/**
 * initialise the game
 */
export function init()
{
    //  initialise the module

    ReactDOM.render(React.createElement(PowerMapGame), document.getElementById('power-map'));

    //  set the embed options

    // store.dispatch(setEmbedOptions(embedOptions));

    //  test log the store

    // logStore();
}



// WEBPACK FOOTER //
// ./src/ts/index.tsx